import React, { useEffect } from "react";
import HeaderOne from "../common/header/Header";
import Breadcrumb from "../common/breadcrumb/Breadcrumb";
import Footer from "../common/footer/Footer";
import WhatWeDoComponent from "../components/what-we-do/WhatWeDo";
import { useLocation } from "react-router-dom";
import SEO from "../common/seo/SEO";

const WhatWeDo = () => {
  const location = useLocation();

  useEffect(() => {
    const hash = location.hash;
    if (hash) {
      const element = document.querySelector(hash);
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    }
  }, [location]);

  return (
    <>
      <SEO path={"/what-we-do"} prefix={"What We Do"} />
      <HeaderOne />
      <Breadcrumb heading="What We Do" currentPage="What We Do" />
      <WhatWeDoComponent />
      <Footer />
    </>
  );
};

export default WhatWeDo;
